import React from 'react';
import { Alert } from 'shards-react';

interface NotificationProps {
  theme: string;
  isOpen: boolean;
  message: string;
  dismissCallback?: () => void;
}

const Notification = React.memo(({ theme, isOpen, message, dismissCallback }: NotificationProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * クローズボタンを押したとき
   */
  const dismiss = (): void => {
    if(dismissCallback) {
      dismissCallback()
    }
  };

  // VIEW
  // ================================================================================

  return (
    <div id="message" className="pb-1">
      <Alert theme={theme} dismissible={dismiss} open={isOpen}>
        {message}
      </Alert>
    </div>
  );
});

Notification.displayName = 'Notification';
export default Notification;
